import React from 'react';
import { ShieldCheck, MapPin, Phone, Clock, Mail, ExternalLink } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gov-navyDark text-gray-300" data-id="element-14">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-16">
          {/* Brand & Mission */}
          <div className="col-span-1 md:col-span-2 lg:col-span-1" data-id="element-17">
            <div className="flex items-center space-x-3 mb-6" data-id="element-18">
              <ShieldCheck className="w-8 h-8 text-gov-amber" data-id="element-19" />
              <div className="flex flex-col" data-id="element-20">
                <span className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-21">
                  Franklin County
                </span>
                <span className="text-lg font-serif font-black text-white leading-tight" data-id="element-22">
                  Public Health
                </span>
              </div>
            </div>
            <p className="text-sm leading-relaxed mb-6" data-id="element-23">
              Dedicated to protecting, promoting, and improving the health and
              well-being of all people in Franklin County through science,
              service, and leadership.
            </p>
            <a href="#report" className="inline-block bg-gov-amber/10 hover:bg-gov-amber/20 text-gov-amber border border-gov-amber/30 font-semibold py-2 px-4 rounded transition-colors text-sm" data-id="element-24">
              Report a Concern
            </a>
          </div>

          {/* Contact Info */}
          <div data-id="element-25">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-26">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm" data-id="element-27">
              <li className="flex items-start" data-id="element-28">
                <MapPin className="w-5 h-5 mr-3 text-gov-amber flex-shrink-0 mt-0.5" data-id="element-29" />
                <span data-id="element-30">
                  1200 Health Center Drive
                  <br data-id="element-31" />
                  Suite 200
                  <br data-id="element-32" />
                  Franklin, FC 12345
                </span>
              </li>
              <li className="flex items-center" data-id="element-33">
                <Phone className="w-5 h-5 mr-3 text-gov-amber flex-shrink-0" data-id="element-34" />
                <span data-id="element-35">(555) 123-4567</span>
              </li>
              <li className="flex items-center" data-id="element-36">
                <Mail className="w-5 h-5 mr-3 text-gov-amber flex-shrink-0" data-id="element-37" />
                <a href="mailto:info@franklincountyhealth.gov" className="hover:text-white transition-colors" data-id="element-38">
                  info@franklincountyhealth.gov
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-39">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-40">
              Hours of Operation
            </h4>
            <ul className="space-y-4 text-sm" data-id="element-41">
              <li className="flex items-start" data-id="element-42">
                <Clock className="w-5 h-5 mr-3 text-gov-amber flex-shrink-0 mt-0.5" data-id="element-43" />
                <div data-id="element-44">
                  <p className="font-semibold text-white mb-1" data-id="element-45">Main Office</p>
                  <p data-id="element-46">
                    Monday - Friday
                    <br data-id="element-47" />
                    8:00 AM - 5:00 PM
                  </p>
                  <p className="text-gray-500 mt-1" data-id="element-48">
                    Closed on County Holidays
                  </p>
                </div>
              </li>
              <li className="mt-4 pt-4 border-t border-gray-800" data-id="element-49">
                <p className="font-semibold text-white mb-1" data-id="element-50">
                  24/7 Emergency Line
                </p>
                <p className="text-gov-amber font-bold" data-id="element-51">(555) 999-1234</p>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-52">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-53">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-54">
              <li data-id="element-55">
                <a href="#" className="hover:text-white hover:underline transition-all" data-id="element-56">
                  Pay a Fee or Fine
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-white hover:underline transition-all" data-id="element-58">
                  Request Records
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="hover:text-white hover:underline transition-all" data-id="element-60">
                  Board of Health Meetings
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="hover:text-white hover:underline transition-all" data-id="element-62">
                  Employment Opportunities
                </a>
              </li>
              <li data-id="element-63">
                <a href="#" className="hover:text-white hover:underline transition-all" data-id="element-64">
                  Public Records Request
                </a>
              </li>
              <li className="pt-2" data-id="element-65">
                <a href="#" className="flex items-center text-gray-400 hover:text-white transition-colors" data-id="element-66">
                  State Dept of Health{' '}
                  <ExternalLink className="w-3.5 h-3.5 ml-1.5" data-id="element-67" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Legal Bar */}
      <div className="bg-[#0a101d] py-6" data-id="element-68">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-69">
          <p data-id="element-70">
            &copy; {new Date().getFullYear()} Franklin County Department of
            Public Health. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-71">
            <a href="#" className="hover:text-gray-300 transition-colors" data-id="element-72">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-300 transition-colors" data-id="element-73">
              Accessibility
            </a>
            <a href="#" className="hover:text-gray-300 transition-colors" data-id="element-74">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>;
}